import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../config/firebase';

/** True when the visitor is a patient using a consent link (not logged into the clinic). */
export function isAnonymousPatientSession() {
  return !auth.currentUser;
}

export function patientDobVerifiedKey(accessToken) {
  return `patient-dob-verified:${String(accessToken || '').trim()}`;
}

export function markPatientDobVerified(accessToken) {
  try {
    sessionStorage.setItem(patientDobVerifiedKey(accessToken), String(Date.now()));
  } catch (_) {
    /* private browsing / storage blocked */
  }
}

export function isPatientDobVerified(accessToken) {
  try {
    return !!sessionStorage.getItem(patientDobVerifiedKey(accessToken));
  } catch (_) {
    return false;
  }
}

export async function callablePatientGetConsentByToken(accessToken, options = {}) {
  const fn = httpsCallable(functions, 'patientGetConsentByToken');
  const { data } = await fn({
    accessToken,
    trackOpened: options.trackOpened !== false,
  });
  return data;
}

export async function callablePatientUpdateConsent(accessToken, action, payload) {
  const fn = httpsCallable(functions, 'patientUpdateConsent');
  const { data } = await fn({ accessToken, action, payload });
  return data;
}

export async function callablePatientQaGetThread(accessToken) {
  const fn = httpsCallable(functions, 'patientQaGetThread');
  const { data } = await fn({ accessToken });
  return data;
}

export async function callablePatientQaEnsureThread(accessToken, meta = {}) {
  const fn = httpsCallable(functions, 'patientQaEnsureThread');
  const { data } = await fn({ accessToken, ...meta });
  return data;
}

export async function callablePatientQaSendMessage(accessToken, text, meta = {}) {
  const fn = httpsCallable(functions, 'patientQaSendMessage');
  const { data } = await fn({ accessToken, text, meta });
  return data;
}

export async function callablePatientQaListMessages(accessToken) {
  const fn = httpsCallable(functions, 'patientQaListMessages');
  const { data } = await fn({ accessToken });
  return data;
}

/** Load consent for patient signing pages — always via Cloud Function, never client Firestore. */
export async function fetchPatientConsentForSigning(accessToken, options = {}) {
  const bundle = await callablePatientGetConsentByToken(accessToken, options);
  const consent = bundle.consent || bundle;
  const clinic = bundle.clinic || {};
  const templates =
    (Array.isArray(consent.templates) && consent.templates.length > 0
      ? consent.templates
      : null) ||
    (Array.isArray(bundle.templates) ? bundle.templates : []) ||
    [];

  return {
    ...consent,
    id: consent.id || bundle.consent?.id || null,
    templates,
    isAIConsent: bundle.isAIConsent === true,
    clinicLogo: clinic.logo || clinic.branding?.logo || null,
    clinicAddress: clinic.address || null,
    clinicPhone: clinic.phone || null,
    clinicEmail: clinic.email || null,
  };
}
